import { styled } from "linaria/react";
import { theme } from "@project/shared/src/theme";
import Head from "next/head";
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w1grjztz"
});
const HeadingWrapper = /*#__PURE__*/styled("div")({
  name: "HeadingWrapper",
  class: "h1ek1qt1"
});
const Description = /*#__PURE__*/styled("div")({
  name: "Description",
  class: "d14f6ehh"
});
const BgDiv = /*#__PURE__*/styled("div")({
  name: "BgDiv",
  class: "bpm5pld"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "cecn7q5"
});
const Subtitle = /*#__PURE__*/styled("h2")({
  name: "Subtitle",
  class: "sdxkoiu"
});
const Banner = /*#__PURE__*/styled("div")({
  name: "Banner",
  class: "b1397fov"
});
const List = /*#__PURE__*/styled("li")({
  name: "List",
  class: "l4jaarz",
  vars: {
    "l4jaarz-1": [({
      bold
    }) => bold ? "bold" : "normal"]
  }
});
const Content = /*#__PURE__*/styled("p")({
  name: "Content",
  class: "csly1s5",
  vars: {
    "csly1s5-1": [({
      bold
    }) => bold ? "bold" : "normal"],
    "csly1s5-2": [({
      center,
      right
    }) => center ? "center" : right ? "right" : "unset"]
  }
});

const Privacy = () => {
  const ListItems = (items: string[]) => <>
      {items.map((each, index) => <List key={index}>{each}</List>)}
    </>;

  const OL = (items: string[]) => <ol>{ListItems(items)}</ol>;

  return <>
      <Head>
        <title>
          個人情報の取扱いについて |
          オフサイトミーティングを一括手配：コワーケーション.com
        </title>
        <meta name="keywords" content="個人情報,取り扱い,コワーケーション,合宿,研修,オフサイトミーティング,チームビルディング,役員合宿," />
        <meta name="description" content="法人の経営合宿やチームビルディング合宿、オフサイトミーティングのために、全国の施設と研修・体験コンテンツを代行して一括手配するコワーケーション.com。個人情報の取り扱いについてはこちらから。コワーケーション.comでは現状の課題やご希望から最適なコワーケーション体験をご提案いたします。" />
      </Head>
      <Banner>
        <Wrapper>
          <HeadingWrapper>
            <h1>PRIVACY</h1>
            <h4>個人情報の取扱いについて</h4>
          </HeadingWrapper>
        </Wrapper>
        <BgDiv>
          <img src={"/terms-bg.svg"} />
        </BgDiv>
      </Banner>
      <Description />
      <Container>
        <Subtitle>個人情報の取扱いの適用範囲</Subtitle>
        <Content>
          {"個人情報の取扱いについては、お客様が本ウェブサイトを含む当社のウェブサイトを通じて商品の購入、サービスの利用、当社へのご連絡、メールマガジンの購読などをご利用された時に適用されます。\n" + "お客様が当社のウェブサイトを利用される際に収集された個人情報は、本「個人情報の取扱いについて」の考え方（以下「本ポリシー」といいます）に従い管理されます。"}
        </Content>

        <Subtitle>個人情報の利用目的</Subtitle>
        <Content>
          当社は、お客様から収集させていただいた個人情報、ご注文情報（お客様の注文履歴に関
          する情報を含む）を、本サービスを提供する目的の他に、以下の各号に定める目的のため
          に利用することがあります。本サービスの提供または以下に定める目的以外に、当社はお
          客様の個人情報を利用することはありません。
        </Content>
        {OL(["お客様の登録受付、本人確認、ユーザー認証、ユーザー設定の記録、利用料金の決済計算等本サービスの提供、維持、保護及び改善のため", "お客様のトラフィック測定及び行動測定のため", "お客様に対して、当社の商品やサービスをご紹介する場合", "当社において、お客様に代行してご注文手続き、ご注文内容の確認、変更手続きを行う場合", "お客様からのお問い合わせに対して回答を行う場合", "お客様に対して、当社のサービスに対するご意見やご感想のご提供をお願いするため", "当社がお客様に別途連絡の上、個別にご了解をいただいた目的に利用するため", "お客様の属性（年齢、住所など）ごとに分類された統計的資料を作成するため", "お客様それぞれの嗜好に適合した情報発信やサービスを提供、表示するため", "本サービスに関する当社の規約、ポリシー等（以下「規約等」といいます。）に違反する行為に対する対応のため", "本サービスに関する規約等の変更などを通知するため"])}
        <Subtitle>個人情報の安全管理について</Subtitle>
        <Content>
          当社は個人情報の正確性及び安全性を確保するため、個人情報へのアクセス管理、持ち出
          し手段の制限、不正アクセス及び、漏洩、紛失、破壊、改ざんなどに対しては、合理的な
          安全対策を講じるとともに、万一、漏洩等個人情報に関する事故が発生した場合には、再
          発防止策を含む適切な対策を速やかに講じます。
        </Content>

        <Subtitle>個人情報の預託について</Subtitle>
        <Content>
          {"当社は、明示した利用目的の達成の為に必要な範囲で業務を預託する場合があります。その場合は、業務委託先の適切な管理及び監督を行います。\n" + "（業務委託先とは、運送業者、ダイレクトメールの発送のための印刷会社、商品代金未払いの場合の回収委託会社等。）"}
        </Content>

        <Subtitle>個人情報の第三者への開示</Subtitle>
        <Content>
          当社は、個人情報を本人の許可無く他の事業者や個人などの第三者に提供及び公開するこ
          とはありません。ただし、以下に該当する場合はその限りではありません。
        </Content>
        {OL(["情報提供について本人の同意がある場合", "官公庁等の公的機関から法令に基づき開示を求められた場合", "本ウェブサイトの運営に関する業務提携先等に対して個人情報を開示する場合。ただし、この場合に開示する情報は必要な範囲のみに限定し、開示先に対して契約等により個人情報の管理を義務付けます。", "合併その他の事由による事業の承継に伴って個人情報が提供される場合", "その他個人情報の保護に関する法律その他の法令で認められる場合"])}
        <Subtitle>クッキーに関して</Subtitle>
        <Content>
          クッキーとは、お客様についての情報を含むお客様のハードドライブに蓄えられる1つの
          データです。クッキーの使用は、当社のサイト上では決して個人特定情報にリンクされま
          せん。お客様がクッキーを拒否する場合でも当サイトを使用することができます。
          当社のウェブサイトでは、サイトのユーザービリティーの向上に役立てるためのアクセス
          ログの収集と、お客様が当社のウェブサイトを再度訪れたときに個人情報入力の手間が省
          け、一層便利に利用していただくために、このクッキーを利用しているページがありま
          す。（なければ削除）
        </Content>
        <Subtitle>
          その他インターネット上のプライバシーに関する確認事項
        </Subtitle>
        {OL(["掲示板など、誰もがアクセスできるインターネット上で自発的に個人情報を開示した場合、その情報は他の利用者によって収集され使用される可能性があることに留意してください。メールアドレスを公開すれば、そこに掲示された情報をもとに、望ましくないメッセージを受け取ることがあります。お客様には自己の責任において情報を発信することを認識していただく必要があります。", "本ウェブサイトを通じてアクセスできる第三者のサイト及びサービス、又は懸賞や販売促進活動などを通して個人情報を収集している企業等は、当社とは独立した個々のプライバシーに関しての規約やデータの収集規約を定めています。当社は、これらの独立した第三者の規約や活動に対していかなる義務や責任も負いません。"])}

        <Subtitle>個人情報の開示</Subtitle>
        <Content bold>
          当社は、お客様ご本人から個人情報の開示を求められたときは、ご本人に対し，遅滞なく
          これを開示します。ただし、開示することにより次のいずれかに該当する場合は，その全
          部または一部を開示しないこともあり，開示しない決定をした場合には，その旨を遅滞な
          く通知します。なお，個人情報の開示に際しては，1件あたり1,000円の手数料を申し受け
          ます。
        </Content>
        <ol>
          <List bold>
            本人または第三者の生命，身体，財産その他の権利利益を害するおそれがある場合
          </List>
          <List bold>
            当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合
          </List>
          <List bold>その他法令に違反することとなる場合</List>
        </ol>

        <Subtitle>個人情報の訂正・削除・利用停止</Subtitle>
        <ol>
          <List bold>
            お客様は、当社の保有する自己の個人情報が誤った情報である場合には、当社が定
            める手続きにより、当社に対して個人情報の訂正、追加または削除（以下、「訂正等」と
            いいます。）を請求することができます。
          </List>
          <List bold>
            当社は、お客様から前項の請求を受けてその請求に応じる必要があると判断した場
            合には、遅滞なく当該個人情報の訂正等を行うものとします。
          </List>
          <List bold>
            当社は、前項の規定に基づき訂正等を行った場合、または訂正等を行わない旨の決
            定をしたときは、遅滞なくこれをお客様に通知します。
          </List>
        </ol>

        <Subtitle>本ポリシーの変更及び通知</Subtitle>
        <Content>
          当社は、本ポリシーについての内容を、当社の営業上の必要性、新法令の施行、既存法令
          の改正その他の事情により、
          変更することがあります。変更する場合は、本ウェブサイト
          に掲示し、お知らせします。
          ご利用の際には本ページの最新の内容をご確認ください。
        </Content>
        <Content>
          {"お問合せ窓口\n" + "本ポリシーに関するご意見、お問い合わせ及び個人情報に関する苦情・相談のお申し出は、下記の窓口までお願いいたします。\n" + "住所：北佐久郡軽井沢町軽井沢1018-15\n" + "社名：PerkUP株式会社\n" + "個人情報保護管理者：斉藤 晴久\n" + "Eメールアドレス：info@perkup.life"}
        </Content>
        <Content>2020年9月26日制定</Content>
      </Container>
    </>;
};

export default Privacy;

require("./index.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");